import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getUserTypeListById, saveUserTypeData, updateUserTypeData } from "../../redux/actions/UserTypeActions";
import FormInput from "../../Components/FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { getAllCityStateWiseList, getAllStateList } from "../../redux/actions/MasterActions";
import Preloader from "../../Components/Preloader";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import '../../styles/common.css'
import { getAllCategoryList } from "../../redux/actions/MasterActions";

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddUserType = ({ show, onHide, editId }) => {
  const { t } = useTranslation();
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [categoryId, setCategoryId] = useState(null);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    userTypeReducer: {
      loadingUserType,
      errorsUserType,
      userTypeLists,
      changedUserTypeStatus,
    },
    masterReducer: {
      loadingMaster,
      masterStateLists,
      masterCityStateWiseLists,
      masterCategoryLists,
    },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    setFormData({})
    if(editId) {
      dispatch(getUserTypeListById(auth?.token, editId));
    }
  }, [auth, editId]);

  useEffect(() => {
    if (auth?.token) {
    dispatch(getAllCategoryList(auth?.token));
    }
  }, [auth?.token]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if(editId){
      dispatch(updateUserTypeData(auth?.token, formData, editId));
    } else {
      dispatch(saveUserTypeData(auth?.token, formData));
    }
  };

  
  useEffect(() => {
    if(editId && userTypeLists && Object.keys(userTypeLists).length > 0) {
      setFormData({
        name: userTypeLists?.name,
        category_id: userTypeLists?.category_id,
      });
      setCategoryId(userTypeLists?.category_id);
    }
  }, [userTypeLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide(); // Close modal on logout
    }
  }, [errors, dispatch, onHide]);


  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  
  useEffect(() => {
    if (changedUserTypeStatus?.success) {
      setFormData({});
      setCategoryId(null);
      setValidated(false);
      onHide();
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedUserTypeStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_DESIGNATION_STATUS' });
    }
  }, [changedUserTypeStatus, dispatch]);


  return (
    <Modal show={show} onHide={onHide} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && userTypeLists && Object.keys(userTypeLists).length > 0) ? t("Update User Type") : t("Add User Type")}</Modal.Title>
      </Modal.Header>
        <Modal.Body>
            {errorsUserType?.data?.message && (
              <div className="alert alert-danger">
                {errorsUserType?.data?.message}
              </div>
            )}
          <Row>

          <Col lg={12}>
            <Form.Group className="mb-3"> <Form.Label>{t("Category")} <span style={{color:'red',fontSize:15}}>*</span></Form.Label>
              <Select
                options={masterCategoryLists}
                values={masterCategoryLists.filter((category) => category.id === categoryId)}
                name="category_id"
                labelField={"name"}
                valueField={"id"}
                loading={loadingMaster}
                searchBy="name"
                onChange={(selectedData) => {
                  const id = selectedData[0]?.id;
                  setCategoryId(id);
                  setFormData({ ...formData, category_id: id });
                }}
              />
              {errorsUserType?.data?.category_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{errorsUserType?.data?.category_id}</p>
                </div>
              )}
            </Form.Group>
            </Col>
          
            <Col lg={12}>
              <FormInput
                label={t("User Type Name")}
                type="text"
                errors={errorsUserType?.data}
                value={formData.name}
                name="name"
                required={true}
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-center">
            {loading ? 
              <Button color="primary" disabled>
                <Spinner animation="border" size="sm" />
                {t("Please wait ...")}
              </Button>
            :
              <Button type="button" onClick={(e) => handleSubmit(e)} disabled={loading}>
              {(editId && userTypeLists && Object.keys(userTypeLists).length > 0) ? t("Update") : t("Add")}
              </Button>
            }
          </div>
        
      </Modal.Body>
      {loadingUserType && <Preloader />}
    </Modal>
  );
};

export default AddUserType;
